import { useLiveStreamAppContext } from "../ContextStore/Store";
import axios from "axios";

const SendPlayerSettings = () => {
  const {
    __appConfirmUniqueID,
    __merchantId,
    __userId,
    appInsightTrack,
    toggleStates,
    setErrorMessage,
    setLoaderAnimation,
    setIsNetworkError,
    role,
    apiUrlPost,
    isMic,
    isCam,
    userName,
    headers,
  } = useLiveStreamAppContext();

  async function setplayersettings() {
    const currentPath = window.location.pathname;
    const newPath1 = currentPath.includes("/recording-playback");
    const newPath2 = currentPath.includes("/feedbackhost");
    const newPath3 = currentPath.includes("/feedback");
    const newPath4 = currentPath.includes("/review");

    if (newPath1 || newPath2 || newPath3 || newPath4) {
      return; // Exit if any of the specified paths are present
    }
        
    let attempt = 0;
    const PlayerSettings = async () => {
      attempt++;
      try {
        setIsNetworkError(false);
        await axios.post(
          `${apiUrlPost}ChangePlayerSettings`,
          role === "Presenter"
            ? {
              AppConfirmUniqueId: __appConfirmUniqueID,
              attendeeType: 1,
              isDisableChatforAllAttendes: !toggleStates["EnableChat"],
              isDisableMichrophoneforAllAttendees: !toggleStates["EnableMic"],
              isDisableScreenShareforAllAttendees: !toggleStates["EnableScreenShare"],
              isDisableVideoforAllAttendes: !toggleStates["EnableVideo"],
              isInstructorOnlyMode: toggleStates["InstructorMode"],
              isMuteOwnAudio: !isMic,
              isMuteOwnVideo: toggleStates["isSelfCam"] !== undefined ? !toggleStates["isSelfCam"] : !isCam,
              screenName: userName,
              isAudioSwitch: isMic,
              IsVideoSwitch: toggleStates["isSelfCam"] !== undefined ? toggleStates["isSelfCam"] : isCam,
              IsChatSwitch: toggleStates["EnableChat"],
              IsScreenShareSwitch: !toggleStates["EnableScreenShare"],
              isStartRecording: toggleStates["StartRecording"],
              isBlurBackGround: toggleStates["blurBackground"],
              isRemoveBackgroundNoise: toggleStates["removeBackgroundNoise"],
              isShareDeviceAudio: toggleStates["shareDeviceAudio"],
              isMirrorVideo: toggleStates["mirrorMyVideo"],
            }
            : {
              AppConfirmUniqueId: __appConfirmUniqueID,
              attendeeType: 2,
              isMuteOwnAudio: !isMic,
              isMuteOwnVideo: toggleStates["isSelfCam"] !== undefined ? !toggleStates["isSelfCam"] : !isCam,
              isAudioSwitch: isMic,
              IsVideoSwitch: toggleStates["isSelfCam"] !== undefined ? toggleStates["isSelfCam"] : isCam,
              IsChatSwitch: toggleStates["EnableChat"],
              IsScreenShareSwitch: !toggleStates["EnableScreenShare"],
              screenName: userName,
              isBlurBackGround: toggleStates["blurBackground"],
              isRemoveBackgroundNoise: toggleStates["removeBackgroundNoise"],
              isShareDeviceAudio: toggleStates["shareDeviceAudio"],
              isMirrorVideo: toggleStates["mirrorMyVideo"],
            },
          { headers }
        );
      } catch (error) {
        setLoaderAnimation(false);
        //setErrorMessage(error.message);
        console.error("Error fetching change player setting response", error);
        appInsightTrack(__merchantId, __userId, "API Error ChangePlayerSettings", "", error);
        if (attempt < 3) {
          await PlayerSettings();
          return;
        }
      }
    };
    await PlayerSettings();
  }
  return { setplayersettings }
}

export default SendPlayerSettings